import { DOMAIN_STATUS } from "@/constant";
import { formErrorMessage } from "@/utility/formErrorMessage";

export default {
  data() {
    return {
      // Only CONNECTED domains
      domainsList: [],
    };
  },
  async created() {
    try {
      const { data } = await this.getAllDomains();
      this.fillDomainListData(data);
    } catch (err) {
      this.$admin.toast.error(formErrorMessage(err, this.$t("generic.error")));
    }
  },
  methods: {
    async getAllDomains() {
      try {
        return await this.$admin.dataProvider.getList("domains", {
          disablePagination: true,
          filter: {
            status: DOMAIN_STATUS.CONNECTED,
          },
        });
      } catch (err) {
        return Promise.reject(err);
      }
    },
    fillDomainListData(data) {
      const domainsList = [...data];
      this.domainsList = domainsList.map(item => {
        return {
          text: item.url,
          value: item["@id"],
          id: item.id,
          sentryEnabled: item.sentryEnabled,
        };
      });
    },
  },
};
